import React, { FC } from "react";

import { Paper, PaperProps, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import SettingsHeader from "./SettingsHeader";

interface StyledPaperProps extends PaperProps {
  active?: boolean;
}

interface SettingsCardProps extends StyledPaperProps {
  title?: string;
  id?: string;
}

const StyledPaper = styled<FC<StyledPaperProps>>(
  ({ active, children, ...props }: StyledPaperProps) => {
    return (
      <Paper elevation={active ? 1 : 0} {...props}>
        {children}
      </Paper>
    );
  }
)(({ theme, active }) => ({
  width: "100%",
  padding: "8px",
  background: "#fff",
  position: "relative",
  borderRadius: "8px",
  margin: "16px 0",
  "&::after": {
    pointerEvents: "none",
    content: "''",
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    borderRadius: "8px",
    border: `${active ? 2 : 1}px solid ${
      active
        ? theme.palette.shades.secondary[400]
        : theme.palette.shades.neutral[100]
    }`,
  },
}));

const SettingsCard = ({
  title,
  active,
  id,
  children,
  ...props
}: SettingsCardProps) => {
  return (
    <StyledPaper {...props}>
      {title && (
        <SettingsHeader active={Boolean(active)} title={title} id={id} />
      )}
      <Stack direction="column" spacing={2} sx={{ p: 2 }}>
        {children}
      </Stack>
    </StyledPaper>
  );
};

export default SettingsCard;
